<div class="knowledge-base-page-container" *ngIf="!isLoadingLabels && !isLoadingAccordion">
	<div
		class="main-col"
		[ngClass]="{ 'focus-view': selectedAccordion && selectedKb.id === '' }"
		[ngStyle]="{ width: ghostResizeBar.mainCol + '%' }">
		<div class="accordion-col" [ngStyle]="{ left: selectedAccordion.id === '' ? '0' : '-100%' }">
			<div class="title">{{ labels.lbl_meus_artigos }}</div>
			<div class="button big" (click)="cleanEntireArchive(); selectedKb.id = '-1'; secondColView = 'kb'">
				{{ labels.lbl_geral_novo }} {{ labels.lbl_geral_artigo }}
			</div>
			<div
				class="button big"
				(click)="
					cleanKbAccordion();
					cleanEntireArchive();
					changeHistory('/knowledgebase');
					selectedKb.id = '-1';
					secondColView = 'searchKb'
				">
				{{ labels.lbl_geral_buscar }} {{ labels.lbl_geral_artigo }}
			</div>

			<div class="accordion-container">
				<div
					class="accordion color-{{ index % 5 }}"
					*ngFor="let accordion of kbAccordion; let index = index"
					(click)="selectedAccordion = accordion">
					<div>
						<span>{{ accordion.name }}</span>
					</div>
					<div class="accordion-length color-{{ index % 5 }}">
						{{
							accordion.kb.length <= 9
								? '000' + accordion.kb.length
								: accordion.kb.length <= 99
									? '00' + accordion.kb.length
									: accordion.kb.length <= 999
										? '0' + accordion.kb.length
										: accordion.kb.length
						}}
					</div>
				</div>
			</div>
		</div>

		<div class="last-upload-col" [ngStyle]="{ left: selectedAccordion.id === '' ? '100%' : '0' }">
			<div class="navigation">
				<span (click)="cleanKbAccordion(); changeHistory('/knowledgebase')">< {{ labels.lbl_meus_artigos }}</span>
				<span>< {{ selectedAccordion.name }}</span>
			</div>

			<div class="title">{{ selectedAccordion.name }}</div>

			<div class="accordion-container">
				<div class="card" *ngFor="let kb of selectedAccordion.kb" (click)="getKbArchive(kb.id); secondColView = 'kb'">
					<span class="bold">{{ labels.lbl_geral_artigo }} {{ kb.id }}</span>
					<span>{{ kb.summary.length > 47 ? kb.summary.slice(0, 45) + '..' : kb.summary }}</span>
					<span>{{ kb.classification[0].solution_area }}</span>
				</div>
			</div>
		</div>
	</div>

	<div
		class="sub-col"
		[ngClass]="{ 'focus-view': selectedKb && selectedKb.id && selectedKb.id !== '' }"
		[ngStyle]="{ width: ghostResizeBar.subCol + '%' }">
		<!--- Criação de Artigos --->
		<div class="register-col" *ngIf="secondColView === 'kb'">
			<div class="header" *ngIf="!isLoadingKbArchive && !isLoadingForm">
				<div class="navigation-container">
					<div class="navigation">
						<span
							(click)="
								cleanEntireArchive(); cleanKbAccordion(); changeHistory('/knowledgebase'); secondColView = 'not-chosen'
							"
							>< {{ labels.lbl_geral_inicio }}&nbsp;</span
						>
						<span *ngIf="selectedKb.id"
							>< {{ selectedKb.status !== 'New' ? 'KB - ' + selectedKb.id : labels.lbl_geral_novo }}</span
						>
					</div>
					<div class="button-container" *ngIf="selectedKb && selectedKb.id && selectedKb.id != '-1'">
						<div class="button" (click)="selectedTab = 'archiveLog'" *ngIf="selectedTab === 'archiveData'">Logs</div>
						<div class="button" (click)="selectedTab = 'archiveData'" *ngIf="selectedTab === 'archiveLog'">
							{{ labels.lbl_geral_voltar }}
						</div>
					</div>
				</div>

				<div
					class="register-navigation"
					[ngClass]="{
						moveNew: selectedKb.status === 'New' || selectedKb.status === 'Draft',
						moveDriver: selectedKb.status === 'Driver approval',
						moveTech: selectedKb.status === 'Tecnical review',
						movePublish: selectedKb.status === 'Published',
						moveRetired: selectedKb.status === 'Retired',
					}">
					<div
						class="navigation-interactive"
						[ngClass]="{
							filled: selectedKb.status && availableStatus.indexOf(selectedKb.status.toString()) >= 2,
							selected: selectedKb.status === 'New' || selectedKb.status === 'Draft',
						}">
						<span class="ball"><fa-icon [icon]="icons.faPencilAlt"></fa-icon></span>
						<span [ngClass]="{ selected: selectedKb.status === 'New' || selectedKb.status === 'Draft' }"
							>{{ labels.lbl_geral_esboco }}
							<ng-container *ngIf="draftStep != null"
								>- {{ labels[draftStep.label] ? labels[draftStep.label] : draftStep.label }}</ng-container
							>
						</span>
					</div>
					<div
						class="navigation-interactive"
						[ngClass]="{
							filled: selectedKb.status && availableStatus.indexOf(selectedKb.status.toString()) >= 3,
							selected: selectedKb.status === 'Driver approval',
						}">
						<span class="ball"><fa-icon [icon]="icons.faEye"></fa-icon></span>
						<span [ngClass]="{ selected: selectedKb.status === 'Driver approval' }">{{ labels.lbl_revisao_driver }}</span>
					</div>
					<div
						class="navigation-interactive"
						[ngClass]="{
							filled: selectedKb.status && availableStatus.indexOf(selectedKb.status.toString()) >= 4,
							selected: selectedKb.status === 'Tecnical review',
						}">
						<span class="ball"><fa-icon [icon]="icons.faWrench"></fa-icon></span>
						<span [ngClass]="{ selected: selectedKb.status === 'Tecnical review' }">{{ labels.lbl_revisao_tecnica }}</span>
					</div>
					<div
						class="navigation-interactive"
						[ngClass]="{
							filled: selectedKb.status && availableStatus.indexOf(selectedKb.status.toString()) >= 4,
							selected: selectedKb.status === 'Published',
						}">
						<span class="ball"><fa-icon [icon]="icons.faUpload"></fa-icon></span>
						<span [ngClass]="{ selected: selectedKb.status === 'Published' }">{{ labels.lbl_edocs_publicado }}</span>
					</div>
					<div
						class="navigation-interactive"
						[ngClass]="{
							filled: selectedKb.status && availableStatus.indexOf(selectedKb.status.toString()) >= 5,
							selected: selectedKb.status === 'Retired',
						}">
						<span class="ball"><fa-icon [icon]="icons.faArchive"></fa-icon></span>
						<span [ngClass]="{ selected: selectedKb.status === 'Retired' }">{{ labels.lbl_geral_arquivado }}</span>
					</div>
				</div>
				<!-- <div class="shade"></div> -->
			</div>

			<div class="register-container" *ngIf="!isLoadingKbArchive && !isLoadingForm && selectedTab === 'archiveData'">
				<div class="draft-container" *ngIf="selectedKb.status === 'New' || selectedKb.status === 'Draft'">
					<div class="tab-container">
						<div class="tab-header">
							<div class="tab" [ngClass]="{ selected: draftStep.name === 'customer' }" (click)="nextDraftStep('')">
								{{ labels.lbl_geral_nivel_acesso }}
							</div>
							<div class="tab" [ngClass]="{ selected: draftStep.name === 'tags' }" (click)="nextDraftStep('customer')">
								TAGS
							</div>
							<div class="tab" [ngClass]="{ selected: draftStep.name === 'classification' }" (click)="nextDraftStep('tags')">
								{{ labels.lbl_cmdb_relacionamento }}
							</div>
							<div
								class="tab"
								[ngClass]="{ selected: draftStep.name === 'content' }"
								(click)="nextDraftStep('classification')">
								{{ labels.lbl_geral_conteudo }}
							</div>
							<div class="tab" [ngClass]="{ selected: draftStep.name === 'resume' }" (click)="nextDraftStep('content')">
								{{ labels.lbl_projetos_resumo }}
							</div>
						</div>
						<div class="tab-body">
							<ng-container *ngIf="draftStep.name === 'customer'">
								<pcp-request-classification-reverse
									[customerList]="selectedCustomerList"
									[onMe]="true"
									[allCustomer]="true"
									[setIdSolutionArea]="lockClassificationGroup"
									[initOn]="'solutionArea'"
									[hideField]="['serviceType']"
									(getClassification)="setClassification($event); getAvailableCustomer()">
								</pcp-request-classification-reverse>

								<cpi-generic-form-gen [setGenericForm]="availableCustomerGenericForm" (valueTap)="tapNewCustomer()">
								</cpi-generic-form-gen>
								<cpi-dot-bounce-loading-effect
									[color]="'var(--primary-color-1)'"
									*ngIf="isLoadingAvailableCustomer"></cpi-dot-bounce-loading-effect>

								<div class="dotted-input-container mt-3">
									<span>{{ labels.lbl_geral_idioma }} *</span>
									<select
										[disabled]="selectedKb.status !== 'New' && selectedKb.status !== 'Draft'"
										(change)="selectedKb.language = $event.target.value">
										<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
										<option [value]="'Portuguese'" [selected]="selectedKb.language === 'Portuguese'">
											{{ labels.lbl_geral_portugues }}
										</option>
										<option [value]="'English'" [selected]="selectedKb.language === 'English'">
											{{ labels.lbl_geral_ingles }}
										</option>
										<option [value]="'Spanish'" [selected]="selectedKb.language === 'Spanish'">
											{{ labels.lbl_geral_espanhol }}
										</option>
										<option [value]="'Slovak'" [selected]="selectedKb.language === 'Slovak'">
											{{ labels.lbl_geral_eslovaco }}
										</option>
										<option [value]="'Chinese'" [selected]="selectedKb.language === 'Chinese'">
											{{ labels.lbl_geral_chines }}
										</option>
										<option [value]="'Italian'" [selected]="selectedKb.language === 'Italian'">
											{{ labels.lbl_geral_italiano }}
										</option>
									</select>
								</div>

								<div class="dotted-input-container mt-1">
									<span>{{ labels.lbl_geral_nivel_acesso }} *</span>
									<select
										[disabled]="selectedKb.status !== 'New' && selectedKb.status !== 'Draft'"
										(change)="selectedKb.visibility = $event.target.value">
										<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
										<option [value]="'public'" [selected]="selectedKb.visibility === 'public'">
											{{ labels.lbl_edocs_publico }}
										</option>
										<option [value]="'private'" [selected]="selectedKb.visibility === 'private'">
											{{ labels.lbl_geral_privado }}
										</option>
										<option [value]="'internal'" [selected]="selectedKb.visibility === 'internal'">
											{{ labels.lbl_geral_uso_interno }}
										</option>
									</select>
									<div class="tip"></div>
								</div>

								<div
									class="dotted-input-container mt-1"
									*ngIf="this.PermissionService.getPermission('edit_responsible_artigo')">
									<span>{{ labels.lbl_geral_responsavel }}</span>
									<cpi-input-with-autocomplete
										[disabled]="selectedKb.status === 'New'"
										[availableOptions]="responsibleListIAC"
										[minInputLength]="2"
										[placeholder]="
											selectedKb.status === 'New'
												? ProfileService.userData().fullName
												: selectedKb.responsible.fullName
										"
										(onValueChange)="setResponsible($event)"
										[setInputText]="selectedKb.responsible.fullName">
									</cpi-input-with-autocomplete>
								</div>

								<div class="button-container">
									<div
										class="button"
										[ngClass]="{
											disabled:
												selectedKb.visibility === '' ||
												selectedKb.language === '' ||
												availableCustomerGenericForm[0]?.values.length == 0,
										}"
										(click)="nextDraftStep('customer')">
										{{ labels.lbl_geral_continuar }}
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="draftStep.name === 'tags'">
								<div class="tag-holder">
									<span class="title" *ngIf="selectedKb.tags.length == 0">{{
										labels.lbl_selecione_tags_relacionadas
									}}</span>
									<span class="tag" *ngFor="let tags of selectedKb.tags; let selectedIndex = index">
										<span>{{ labels[tags[userLanguage]] ? labels[tags[userLanguage]] : tags[userLanguage] }}</span>
										<span
											><fa-icon [icon]="icons.faTimes" (click)="selectedKb.tags.splice(selectedIndex, 1)"></fa-icon
										></span>
									</span>
								</div>

								<app-knowledge-management-tags
									[canAdd]="false"
									[canEdit]="false"
									[hideTitle]="true"
									[selectOnlyLast]="true"
									[customerList]="selectedCustomerList"
									(getSelectedTags)="setLastSelectedTag($event)">
								</app-knowledge-management-tags>

								<div class="button-container">
									<div class="button" [ngClass]="{ disabled: lastSelectedTag == null }" (click)="setDraftTag()">
										{{ labels.lbl_adicionar_tag }}
									</div>
									<div
										class="button"
										[ngClass]="{ disabled: selectedKb.tags.length == 0 }"
										(click)="nextDraftStep('tags')">
										{{ labels.lbl_geral_continuar }}
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="draftStep.name === 'classification'">
								<div class="to-add-classification-container">
									<span class="tab">{{ labels.lbl_adicionar_relacionamento }}</span>
									<div class="button-container">
										<cpi-checkbox
											[color]="'var(--primary-color-1)'"
											[colorChecked]="'var(--primary-color-2)'"
											[shared]="classificationStep"
											[value]="'classification'"
											(oValue)="cleanRelationType(); classificationStep = $event"
											[hideUncheck]="true"
											[innerText]="labels.lbl_geral_classificacao"></cpi-checkbox>
										<cpi-checkbox
											[color]="'var(--primary-color-1)'"
											[colorChecked]="'var(--primary-color-2)'"
											[shared]="classificationStep"
											[value]="'request'"
											(oValue)="cleanRelationType(); classificationStep = $event"
											[hideUncheck]="true"
											[innerText]="labels.lbl_geral_chamado"></cpi-checkbox>
										<cpi-checkbox
											[color]="'var(--primary-color-1)'"
											[colorChecked]="'var(--primary-color-2)'"
											[shared]="classificationStep"
											[value]="'cmdb'"
											(oValue)="cleanRelationType(); classificationStep = $event"
											[hideUncheck]="true"
											[innerText]="labels.lbl_cmdb"></cpi-checkbox>
									</div>
									<div class="dotted-input-container" *ngIf="classificationStep !== ''">
										<span>{{ labels.lbl_geral_cliente }}</span>
										<select (change)="setClassificationCustomer($event.target.value)">
											<option [value]="''" [selected]="kmClassification.idCustomer === ''">
												{{ labels.lbl_geral_selecione }}
											</option>
											<option
												[value]="customer.values[0] + ',' + customer.name"
												[selected]="kmClassification.idCustomer == customer.values[0]"
												*ngFor="let customer of selectedKb.customer">
												{{ customer.name }}
											</option>
										</select>
									</div>
									<div
										class="to-add-classification-form"
										*ngIf="classificationStep === 'classification' && kmClassification.idCustomer !== ''">
										<pcp-request-classification-reverse
											[customerList]="selectedCustomerList"
											[onMe]="true"
											[setIdSolutionArea]="lockClassificationGroup"
											[initOn]="'solutionArea'"
											[hideField]="['serviceType']"
											[lockField]="lockClassificationGroup !== '' ? ['solutionArea'] : []"
											(getClassification)="setClassification($event)">
										</pcp-request-classification-reverse>

										<pcp-request-classification-reverse
											[customerList]="kmClassification.idCustomer"
											[onMe]="true"
											[setIdSolutionArea]="
												lockClassificationGroup ? lockClassificationGroup : kmClassification.id_solution_area
											"
											[initOn]="'serviceType'"
											[hideField]="['solutionArea', 'impact', 'urgency', 'severity']"
											[lockField]="lockClassificationGroup !== '' ? ['solutionArea'] : []"
											(getClassification)="setClassification($event)"
											*ngIf="kmClassification.id_solution_area !== ''">
										</pcp-request-classification-reverse>
									</div>

									<div
										class="to-add-classification-form"
										*ngIf="classificationStep === 'request' && kmClassification.idCustomer !== ''">
										<div class="dotted-input-container" *ngIf="lockClassificationGroup">
											<span>{{ labels.lbl_grupo }}</span>
											<input [value]="lockClassificationGroupName" disabled />
										</div>
										<cpi-generic-form-gen [labels]="labels" [boldLabel]="false" [setGenericForm]="searchFormRequest">
										</cpi-generic-form-gen>

										<div class="button-container">
											<div class="button" (click)="openModalEvaluationMSP()">
												{{ labels.lbl_geral_avaliar }} MySupport
											</div>
											<div *ngIf="classificationStep === 'request'" class="button" (click)="searchRequest()">
												<span>{{ labels.lbl_geral_buscar }}</span>
												<cpi-dot-bounce-loading-effect
													[color]="'var(--const-white)'"
													*ngIf="isLoadingSearchRequest"></cpi-dot-bounce-loading-effect>
											</div>
										</div>

										<ng-container *ngIf="requestListIAC?.length > 0">
											<cpi-input-with-autocomplete
												[availableOptions]="requestListIAC"
												[minInputLength]="0"
												[placeholder]="labels.lbl_rep_custom_id_32"
												(onValueChange)="setRequestData($event)">
											</cpi-input-with-autocomplete>

											<cpi-msp-table
												[header]="classificationCustomerTableHeader"
												[body]="requestList"
												[height]="'30dvh'"
												[itemPadding]="'1%'"
												[labels]="labels"
												[insideSort]="true"
												[sortDown]="true"
												[markLastSelectedItem]="true"
												(getSelectedItem)="setRequestData($event[0]['id'])">
											</cpi-msp-table>
										</ng-container>
									</div>

									<div
										class="to-add-classification-form"
										*ngIf="classificationStep === 'cmdb' && kmClassification.idCustomer !== ''">
										<pcp-cmdb-search-filter
											[customer]="kmClassification.idCustomer"
											[hideFilters]="['customer']"
											(getSelectedCi)="setCmdb($event)">
										</pcp-cmdb-search-filter>
									</div>

									<div class="button-container">
										<div
											class="button"
											[ngClass]="{
												disabled:
													kmClassification.classification.id_topic === '' &&
													kmClassification.request.id === '' &&
													kmClassification.cmdb.idCmdb === '',
											}"
											(click)="addClassification()">
											{{ labels.lbl_geral_adicionar }}
										</div>
									</div>
								</div>

								<div class="added-classification-container">
									<span>{{ labels.lbl_cmdb_relacionamentos_adicionados }}</span>
									<div class="added-classification-header">
										<div
											class="tab"
											[ngClass]="{
												selected: selectedClassificationTab === 'classification',
												notify: notifyAddedClassification == true,
											}"
											(click)="notifyAddedClassification = false; selectedClassificationTab = 'classification'">
											{{ labels.lbl_geral_classificacao }}
										</div>
										<div
											class="tab"
											[ngClass]="{
												selected: selectedClassificationTab === 'request',
												notify: notifyAddedRequest == true,
											}"
											(click)="notifyAddedRequest = false; selectedClassificationTab = 'request'">
											{{ labels.lbl_geral_chamado }}
										</div>
										<div
											class="tab"
											[ngClass]="{ selected: selectedClassificationTab === 'cmdb', notify: notifyAddedCmdb == true }"
											(click)="notifyAddedCmdb = false; selectedClassificationTab = 'cmdb'">
											{{ labels.lbl_cmdb }}
										</div>
									</div>
									<div class="added-classification-body">
										<div
											class="classification-card"
											*ngIf="(selectedKb.classification | callback: kbClassificationFilter).length == 0">
											{{ labels.lbl_nenhum_item_tipo_registrado }}
										</div>
										<div
											class="classification-card"
											*ngFor="let classification of selectedKb.classification | callback: kbClassificationFilter">
											<span>
												{{ classification.customer }} -
												<ng-container *ngIf="classification.cmdb.idCmdb">
													{{ classification.cmdb.idCmdb }} - {{ classification.cmdb.identification }}
												</ng-container>
												<ng-container *ngIf="classification.request.id">
													{{ classification.solution_area }} - {{ classification.request.id }} -
													{{ classification.request.summary }}
												</ng-container>
												<ng-container *ngIf="classification.classification.topic">
													{{ classification.solution_area }} - {{ classification.classification.scope }} -
													{{ classification.classification.category }} - {{ classification.classification.topic }}
												</ng-container>
											</span>
											<span (click)="removeClassification(selectedKb.classification.indexOf(classification))">
												<fa-icon [icon]="icons.faTimes"></fa-icon>
											</span>
										</div>
									</div>
								</div>

								<div class="button-container">
									<div
										class="button"
										[ngClass]="{ disabled: selectedKb.classification.length == 0 }"
										(click)="nextDraftStep('classification')">
										{{ labels.lbl_geral_continuar }}
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="draftStep.name === 'content'">
								<input
									class="large-input"
									[placeholder]="labels.lbl_titulo_artigo + ' *'"
									[value]="selectedKb.summary"
									(input)="selectedKb.summary = $event.target.value" />

								<div class="title">{{ labels.lbl_informacoes_artigo }}</div>
								<angular-editor
									[config]="editorConfig"
									[(ngModel)]="selectedKb.description"
									*ngIf="selectedKb.status === 'New' || selectedKb.status === 'Draft'">
								</angular-editor>

								<div class="button-container">
									<div
										class="button"
										[ngClass]="{ disabled: selectedKb.summary.trim() === '' || selectedKb.description.trim() === '' }"
										(click)="nextDraftStep('content')">
										{{ labels.lbl_geral_continuar }}
									</div>
								</div>
							</ng-container>

							<ng-container *ngIf="draftStep.name === 'resume'">
								<div class="resume-container">
									<span class="resume-label">{{ labels.lbl_geral_cliente }}</span>
									<div *ngFor="let customer of selectedKb.customer">
										<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span> <span>{{ customer.name }}</span>
									</div>
								</div>

								<div class="resume-container">
									<span class="resume-label">{{ labels.lbl_geral_idioma }}</span>
									<div>
										<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
										<span>{{
											selectedKb.language === 'Portuguese'
												? labels.lbl_geral_portugues
												: selectedKb.language === 'English'
													? labels.lbl_geral_ingles
													: selectedKb.language === 'Spanish'
														? labels.lbl_geral_espanhol
														: selectedKb.language === 'Slovak'
															? labels.lbl_geral_eslovaco
															: selectedKb.language === 'Chinese'
																? labels.lbl_geral_chines
																: labels.lbl_geral_italiano
										}}</span>
									</div>
								</div>

								<div class="resume-container">
									<span class="resume-label">{{ labels.lbl_geral_nivel_acesso }}</span>
									<div>
										<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
										<span>{{
											selectedKb.visibility === 'public'
												? labels.lbl_edocs_publico
												: selectedKb.visibility === 'internal'
													? labels.lbl_edocs_interno
													: labels.lbl_geral_privado
										}}</span>
										<br />
										<div *ngIf="selectedKb.responsible.id || ''">
											<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
											<span>{{ labels.lbl_geral_responsavel }}: </span>
											<span>{{ selectedKb.responsible.fullName }}</span>
										</div>
									</div>
								</div>

								<div class="tag-holder no-limit">
									<span class="tag" *ngFor="let tags of selectedKb.tags; let selectedIndex = index">
										<span>{{ labels[tags[userLanguage]] ? labels[tags[userLanguage]] : tags[userLanguage] }}</span>
										<span><fa-icon [icon]="icons.faTag"></fa-icon></span>
									</span>
								</div>

								<div class="added-classification-container">
									<div class="added-classification-header">
										<div
											class="tab"
											[ngClass]="{
												selected: selectedClassificationTab === 'classification',
												notify: notifyAddedClassification,
											}"
											(click)="selectedClassificationTab = 'classification'">
											{{ labels.lbl_geral_classificacao }}
										</div>
										<div
											class="tab"
											[ngClass]="{ selected: selectedClassificationTab === 'request', notify: notifyAddedRequest }"
											(click)="selectedClassificationTab = 'request'">
											{{ labels.lbl_geral_chamado }}
										</div>
										<div
											class="tab"
											[ngClass]="{ selected: selectedClassificationTab === 'cmdb', notify: notifyAddedCmdb }"
											(click)="selectedClassificationTab = 'cmdb'">
											{{ labels.lbl_cmdb }}
										</div>
									</div>
									<div class="added-classification-body">
										<div
											class="classification-card"
											*ngIf="(selectedKb.classification | callback: kbClassificationFilter).length == 0">
											{{ labels.lbl_nenhum_item_tipo_registrado }}
										</div>
										<div
											class="classification-card"
											*ngFor="let classification of selectedKb.classification | callback: kbClassificationFilter">
											<span>
												{{ classification.customer }} - {{ classification.solution_area }} -
												<ng-container *ngIf="classification.cmdb.idCmdb">
													{{ classification.cmdb.idCmdb }} - {{ classification.cmdb.identification }}
												</ng-container>
												<ng-container *ngIf="classification.request.id">
													{{ classification.request.id }} - {{ classification.request.summary }}
												</ng-container>
												<ng-container *ngIf="classification.classification.topic">
													{{ classification.classification.scope }} -
													{{ classification.classification.category }} - {{ classification.classification.topic }}
												</ng-container>
											</span>
											<span (click)="removeClassification(selectedKb.classification.indexOf(classification))">
												<fa-icon [icon]="icons.faTimes"></fa-icon>
											</span>
										</div>
									</div>
								</div>

								<div class="resume-container">
									<div class="resume-label">{{ labels.lbl_geral_summary }}</div>
									<div [innerHTML]="selectedKb.summary"></div>
								</div>
								<div class="resume-container">
									<div class="resume-label">{{ labels.lbl_geral_informacoes }}</div>
									<div [innerHTML]="selectedKb.description"></div>
								</div>

								<div class="button-container end">
									<ng-container *ngIf="selectedKb.status === 'New'">
										<div
											class="button"
											[ngClass]="{ disabled: isLoadingNextStep }"
											(click)="selectedKb.to_publisher = 0; selectedKb.version = '0.1'; createKb()">
											{{ labels.lbl_geral_salvar }}
										</div>
										<div
											class="button"
											[ngClass]="{ disabled: isLoadingNextStep }"
											(click)="selectedKb.to_publisher = 1; selectedKb.version = '0.2'; createKb()">
											{{ labels.lbl_kb_criar }} {{ labels.lbl_geral_e }}
											{{ labels.lbl_enviar_aprovacao.toLowerCase() }}
										</div>
									</ng-container>

									<ng-container
										*ngIf="
											selectedKb.status === 'Draft' && ProfileService.userData().email === selectedKb.registered_by
										">
										<div class="button" [ngClass]="{ disabled: isLoadingNextStep }" (click)="deleteKb()">
											{{ labels.lbl_geral_excluir }}
										</div>
										<div
											class="button"
											[ngClass]="{ disabled: isLoadingNextStep }"
											(click)="selectedKb.to_publisher = 0; updateVersion(0.1); updateKb()">
											{{ labels.lbl_geral_salvar }}
										</div>
										<div
											class="button"
											[ngClass]="{ disabled: isLoadingNextStep }"
											(click)="selectedKb.to_publisher = 1; updateVersion(0.1); updateKb('Driver approval')">
											{{ labels.lbl_enviar_aprovacao }}
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
				</div>

				<div
					class="review-container"
					*ngIf="
						selectedKb.status === 'Driver approval' ||
						selectedKb.status === 'Tecnical review' ||
						selectedKb.status === 'Published'
					">
					<div class="tab-container">
						<div class="tab-header">
							<div class="tab selected">{{ labels.lbl_projetos_resumo }}</div>
						</div>
						<div class="tab-body">
							<div class="resume-container">
								<span class="resume-label">{{ labels.lbl_geral_cliente }}</span>
								<div *ngFor="let customer of selectedKb.customer">
									<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span> <span>{{ customer.name }}</span>
								</div>
							</div>

							<div class="resume-container">
								<span class="resume-label">{{ labels.lbl_geral_idioma }}</span>
								<div>
									<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
									<span>{{
										selectedKb.language === 'Portuguese'
											? labels.lbl_geral_portugues
											: selectedKb.language === 'English'
												? labels.lbl_geral_ingles
												: selectedKb.language === 'Spanish'
													? labels.lbl_geral_espanhol
													: selectedKb.language === 'Slovak'
														? labels.lbl_geral_eslovaco
														: selectedKb.language === 'Chinese'
															? labels.lbl_geral_chines
															: labels.lbl_geral_italiano
									}}</span>
								</div>
							</div>

							<div class="resume-container">
								<span class="resume-label">{{ labels.lbl_geral_nivel_acesso }}</span>
								<div>
									<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
									<span>{{
										selectedKb.visibility === 'public'
											? labels.lbl_edocs_publico
											: selectedKb.visibility === 'internal'
												? labels.lbl_edocs_interno
												: labels.lbl_geral_privado
									}}</span>
									<br />
									<div *ngIf="selectedKb.responsible || ''">
										<span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
										<span>{{ labels.lbl_geral_responsavel }}: </span>
										<span>{{ selectedKb.responsible.fullName }}</span>
									</div>
								</div>
							</div>

							<div class="tag-holder no-limit">
								<span class="tag" *ngFor="let tags of selectedKb.tags; let selectedIndex = index">
									<span>{{ labels[tags[userLanguage]] ? labels[tags[userLanguage]] : tags[userLanguage] }}</span>
									<span><fa-icon [icon]="icons.faTag"></fa-icon></span>
								</span>
							</div>

							<div class="added-classification-container">
								<div class="added-classification-header">
									<div
										class="tab"
										[ngClass]="{
											selected: selectedClassificationTab === 'classification',
											notify: notifyAddedClassification == true,
										}"
										(click)="notifyAddedClassification = false; selectedClassificationTab = 'classification'">
										{{ labels.lbl_geral_classificacao }}
									</div>
									<div
										class="tab"
										[ngClass]="{
											selected: selectedClassificationTab === 'request',
											notify: notifyAddedRequest == true,
										}"
										(click)="notifyAddedRequest = false; selectedClassificationTab = 'request'">
										{{ labels.lbl_geral_chamado }}
									</div>
									<div
										class="tab"
										[ngClass]="{ selected: selectedClassificationTab === 'cmdb', notify: notifyAddedCmdb == true }"
										(click)="notifyAddedCmdb = false; selectedClassificationTab = 'cmdb'">
										{{ labels.lbl_cmdb }}
									</div>
								</div>
								<div class="added-classification-body">
									<div
										class="classification-card"
										*ngIf="(selectedKb.classification | callback: kbClassificationFilter).length == 0">
										{{ labels.lbl_nenhum_item_tipo_registrado }}
									</div>
									<div
										class="classification-card"
										*ngFor="let classification of selectedKb.classification | callback: kbClassificationFilter">
										<span>
											{{ classification.customer }} -
											<ng-container *ngIf="classification.cmdb.idCmdb">
												{{ classification.solution_area }} - {{ classification.cmdb.idCmdb }} -
												{{ classification.cmdb.identification }}
											</ng-container>
											<ng-container *ngIf="classification.request.id">
												{{ classification.solution_area }} - {{ classification.request.id }} -
												{{ classification.request.summary }}
											</ng-container>
											<ng-container *ngIf="classification.classification.topic">
												{{ classification.classification.scope }} - {{ classification.classification.category }} -
												{{ classification.classification.topic }}
											</ng-container>
										</span>
										<span (click)="removeClassification(selectedKb.classification.indexOf(classification))">
											<fa-icon [icon]="icons.faTimes"></fa-icon>
										</span>
									</div>
								</div>
							</div>
							<div class="resume-container">
								<div class="resume-label">{{ labels.lbl_geral_summary }}</div>
								<div [innerHTML]="selectedKb.summary"></div>
							</div>
							<div class="resume-container">
								<div class="resume-label">{{ labels.lbl_geral_informacoes }}</div>
								<div [innerHTML]="selectedKb.description"></div>
							</div>

							<div class="button-container end">
								<ng-container
									*ngIf="
										selectedKb.status === 'Driver approval' && ProfileService.userData().idAnalyst === selectedKb.driver
									">
									<div
										class="button"
										[ngClass]="{ selected: reproveLog.idLog === '' }"
										(click)="reproveLog.idLog === '-1' ? (reproveLog.idLog = '') : (reproveLog.idLog = '-1')">
										{{ labels.lbl_edocs_reprovar }}
									</div>
									<div
										class="button"
										[ngClass]="{ disabled: isLoadingNextStep }"
										(click)="selectedKb.approved = 1; updateVersion(0.1); updateKb('Tecnical review')">
										{{ labels.lbl_chamado_aprovar }}
									</div>
								</ng-container>

								<ng-container
									*ngIf="
										selectedKb.status === 'Tecnical review' &&
										ProfileService.userData().idAnalyst === selectedKb.problem_manager
									">
									<div
										class="button"
										[ngClass]="{ selected: reproveLog.idLog === '' }"
										(click)="reproveLog.idLog === '-1' ? (reproveLog.idLog = '') : (reproveLog.idLog = '-1')">
										{{ labels.lbl_edocs_reprovar }}
									</div>
									<div
										class="button"
										[ngClass]="{ disabled: isLoadingNextStep }"
										(click)="selectedKb.active = 1; updateVersion(1); updateKb('Published')">
										{{ labels.lbl_edocs_publicar }}
									</div>
								</ng-container>

								<ng-container
									*ngIf="
										selectedKb.status === 'Published' && ProfileService.userData().email === selectedKb.registered_by
									">
									<div
										class="button"
										[ngClass]="{ disabled: isLoadingNextStep }"
										(click)="
											selectedKb.active = 0; selectedKb.approved = 0; selectedKb.to_publisher = 0; updateKb('Draft')
										">
										{{ labels.lbl_retornar_para_esboco }}
									</div>
								</ng-container>
							</div>

							<div class="reprove-container" *ngIf="reproveLog.idLog === ''">
								<span class="label">{{ labels.lbl_geral_motivo }} *</span>
								<textarea [rows]="3" (input)="reproveLog.notes = $event.target.value"></textarea>

								<div class="button-container">
									<div
										class="button"
										[ngClass]="{ disabled: isLoadingNextStep }"
										(click)="
											selectedKb.active = 0; selectedKb.approved = 0; selectedKb.to_publisher = 0; updateKb('Draft')
										">
										{{ labels.lbl_confirmar_reprovacao }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="log-container" *ngIf="selectedTab === 'archiveLog'">
				<div class="review-container">
					<div class="tab-container">
						<div class="tab-header">
							<div
								class="tab"
								[ngClass]="{ selected: selectedLogType === 'Registry' }"
								(click)="selectedLogType = 'Registry'">
								{{ labels.lbl_asset_informacoes_tecnicas }}
							</div>
							<div
								class="tab"
								[ngClass]="{ selected: selectedLogType === 'Comments' }"
								(click)="selectedLogType = 'Comments'">
								{{ labels.lbl_geral_comentarios }}
							</div>
						</div>
						<div class="tab-body">
							<ng-container *ngIf="!isLoadingKbLogs">
								<div class="new-log-container">
									<span class="label">{{ labels.lbl_adicionar_nova_log }}</span>
									<textarea [rows]="3" (input)="newLog.notes = $event.target.value"></textarea>

									<div class="button-container">
										<div class="button" (click)="createLog()">
											{{ labels.lbl_adicionar_nova_log }}
										</div>
									</div>
								</div>

								<ng-container *ngFor="let log of logs.slice().reverse()">
									<div
										class="log"
										*ngIf="selectedLogType === 'Comments' ? log.status === 'Comments' : log.status !== 'Comments'">
										<span class="log-date">{{ DateService.formatDate(log.log_date) }} - {{ log.status }}</span>
										<span class="log-date">{{ log.analyst }}</span>
										<span class="log-notes" [innerHTML]="log.notes"></span>
									</div>
								</ng-container>
							</ng-container>

							<cpi-dot-bounce-loading-effect
								[color]="'var(--primary-color-1)'"
								*ngIf="isLoadingKbLogs"></cpi-dot-bounce-loading-effect>
						</div>
					</div>
				</div>
			</div>

			<div class="loading-container" *ngIf="isLoadingKbArchive || isLoadingForm">
				<cpi-svg-gears></cpi-svg-gears>
				<div>{{ labels.lbl_edocs_carregando }}!</div>
			</div>
		</div>

		<!--- Busca de artigos --->
		<div class="register-col" *ngIf="secondColView === 'searchKb'" [ngStyle]="{ 'justify-content': 'flex-start' }">
			<!--- Header --->
			<div class="search-header" *ngIf="!isLoadingKbArchive && !isLoadingForm && !isLoadingAvailableCustomer">
				<div class="navigation-container">
					<div class="navigation">
						<span
							(click)="
								cleanEntireArchive(); cleanKbAccordion(); changeHistory('/knowledgebase'); secondColView = 'not-chosen'
							"
							>< {{ labels.lbl_geral_inicio }}&nbsp;</span
						>
						<span *ngIf="selectedKb.id"
							>< {{ selectedKb.status !== 'New' ? 'KB - ' + selectedKb.id : labels.lbl_geral_buscar }}</span
						>
					</div>
				</div>
			</div>

			<!--- Filtros de pesquisa --->
			<div class="search-container">
				<!--- Nível de Acesso --->
				<div>
					<div class="tab-header">
						<div
							class="content-col-header"
							[ngClass]="{ open: tabVisible['customer'] }"
							(click)="tabVisible['customer'] = !tabVisible['customer']">
							<span>{{ labels.lbl_geral_cliente }}</span>
							<div class="icon-rotate">
								<span [ngClass]="{ rotate: tabVisible['customer'] }" class="icon-arrow">
									<fa-icon [icon]="icons.faChevronDown"></fa-icon>
								</span>
							</div>
						</div>
					</div>
					<div class="search-tab" *ngIf="tabVisible['customer']">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_idioma }}</span>
							<select (change)="searchKbInterface.language = $event.target.value">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="'Portuguese'" [selected]="searchKbInterface.language === 'Portuguese'">
									{{ labels.lbl_geral_portugues }}
								</option>
								<option [value]="'English'" [selected]="searchKbInterface.language === 'English'">
									{{ labels.lbl_geral_ingles }}
								</option>
								<option [value]="'Spanish'" [selected]="searchKbInterface.language === 'Spanish'">
									{{ labels.lbl_geral_espanhol }}
								</option>
								<option [value]="'Slovak'" [selected]="searchKbInterface.language === 'Slovak'">
									{{ labels.lbl_geral_eslovaco }}
								</option>
								<option [value]="'Chinese'" [selected]="searchKbInterface.language === 'Chinese'">
									{{ labels.lbl_geral_chines }}
								</option>
								<option [value]="'Italian'" [selected]="searchKbInterface.language === 'Italian'">
									{{ labels.lbl_geral_italiano }}
								</option>
							</select>
						</div>

						<div class="dotted-input-container mt-1">
							<span>{{ labels.lbl_geral_visibilidade }}</span>
							<select (change)="searchKbInterface.visibility = $event.target.value">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="'public'" [selected]="searchKbInterface.visibility === 'public'">
									{{ labels.lbl_edocs_publico }}
								</option>
								<option [value]="'private'" [selected]="searchKbInterface.visibility === 'private'">
									{{ labels.lbl_geral_privado }}
								</option>
								<option [value]="'internal'" [selected]="searchKbInterface.visibility === 'internal'">
									{{ labels.lbl_geral_uso_interno }}
								</option>
							</select>
						</div>

						<div class="dotted-input-container mt-1">
							<span>{{ labels.lbl_geral_responsavel }}</span>
							<cpi-input-with-autocomplete
								[placeholder]="labels.lbl_preencha_nome"
								[cleanValues]="clearValuesResponsible"
								(getInputText)="searchKbInterface.responsible = $event">
							</cpi-input-with-autocomplete>
						</div>
					</div>
				</div>

				<!--- TAGS --->
				<div>
					<div class="tab-header">
						<div
							class="content-col-header"
							[ngClass]="{ open: tabVisible['tags'] }"
							(click)="tabVisible['tags'] = !tabVisible['tags']">
							<span>TAGS</span>
							<div class="icon-rotate">
								<span [ngClass]="{ rotate: tabVisible['tags'] }" class="icon-arrow">
									<fa-icon [icon]="icons.faChevronDown"></fa-icon>
								</span>
							</div>
						</div>
					</div>
					<div class="search-tab" *ngIf="tabVisible['tags']">
						<div class="tag-holder">
							<span class="title" *ngIf="searchKbInterface.tags.length == 0">{{
								labels.lbl_selecione_tags_relacionadas
							}}</span>
							<div class="tag" *ngFor="let tags of searchKbInterface.tags; let selectedIndex = index">
								<span>{{ labels[tags[userLanguage]] ? labels[tags[userLanguage]] : tags[userLanguage] }}</span>
								<span
									><fa-icon [icon]="icons.faTimes" (click)="searchKbInterface.tags.splice(selectedIndex, 1)"></fa-icon
								></span>
							</div>
						</div>

						<app-knowledge-management-tags
							[canAdd]="false"
							[canEdit]="false"
							[hideTitle]="true"
							[selectOnlyLast]="true"
							[customerList]="selectedCustomerList"
							(getSelectedTags)="setLastSelectedTag($event)">
						</app-knowledge-management-tags>

						<div class="button-container">
							<div class="button" [ngClass]="{ disabled: lastSelectedTag == null }" (click)="searchSelectTagFilter()">
								{{ labels.lbl_adicionar_tag }}
							</div>
						</div>
					</div>
				</div>

				<!--- Classification --->
				<div>
					<div class="tab-header">
						<div
							class="content-col-header"
							[ngClass]="{ open: tabVisible['classification'] }"
							(click)="tabVisible['classification'] = !tabVisible['classification']">
							<span>{{ labels.lbl_cmdb_relacionamento }}</span>
							<div class="icon-rotate">
								<span [ngClass]="{ rotate: tabVisible['classification'] }" class="icon-arrow">
									<fa-icon [icon]="icons.faChevronDown"></fa-icon>
								</span>
							</div>
						</div>
					</div>

					<div class="search-tab" *ngIf="tabVisible['classification']">
						<div class="to-add-classification-container">
							<span class="tab">{{ labels.lbl_adicionar_relacionamento }}</span>
							<div class="button-container">
								<cpi-checkbox
									[color]="'var(--primary-color-1)'"
									[colorChecked]="'var(--primary-color-2)'"
									[shared]="classificationStep"
									[value]="'classification'"
									(oValue)="cleanRelationType(); classificationStep = $event"
									[hideUncheck]="true"
									[innerText]="labels.lbl_geral_classificacao"></cpi-checkbox>
								<cpi-checkbox
									[color]="'var(--primary-color-1)'"
									[colorChecked]="'var(--primary-color-2)'"
									[shared]="classificationStep"
									[value]="'request'"
									(oValue)="cleanRelationType(); classificationStep = $event"
									[hideUncheck]="true"
									[innerText]="labels.lbl_geral_chamado"></cpi-checkbox>
								<cpi-checkbox
									[color]="'var(--primary-color-1)'"
									[colorChecked]="'var(--primary-color-2)'"
									[shared]="classificationStep"
									[value]="'cmdb'"
									(oValue)="cleanRelationType(); classificationStep = $event"
									[hideUncheck]="true"
									[innerText]="labels.lbl_cmdb"></cpi-checkbox>
							</div>

							<div class="dotted-input-container" *ngIf="classificationStep !== ''">
								<span>{{ labels.lbl_geral_cliente }}</span>
								<select (change)="setClassificationCustomer($event.target.value)">
									<option [value]="''" [selected]="kmClassification.idCustomer === ''">
										{{ labels.lbl_geral_selecione }}
									</option>
									<option
										[value]="customer.values[0] + ',' + customer.name"
										[selected]="kmClassification.idCustomer == customer.values[0]"
										*ngFor="let customer of searchAvailableCustomerGenericForm[0].items">
										{{ customer.name }}
									</option>
								</select>
							</div>

							<div *ngIf="classificationStep === 'classification'">
								<pcp-request-classification-reverse
									[customerList]="this.kmClassification.idCustomer"
									[onMe]="true"
									[initOn]="'solutionArea'"
									(getClassification)="setClassification($event)"
									*ngIf="kmClassification.idCustomer !== ''">
								</pcp-request-classification-reverse>
							</div>

							<div *ngIf="classificationStep === 'request' && kmClassification.idCustomer !== ''">
								<div class="dotted-input-container" *ngIf="lockClassificationGroup">
									<span>{{ labels.lbl_grupo }}</span>
									<input [value]="lockClassificationGroupName" disabled />
								</div>
								<cpi-generic-form-gen [labels]="labels" [boldLabel]="false" [setGenericForm]="searchFormRequestArticle">
								</cpi-generic-form-gen>
								<br />
								<cpi-input-with-autocomplete
									[availableOptions]="requestListIAC"
									[minInputLength]="0"
									[placeholder]="labels.lbl_rep_custom_id_32"
									(onValueChange)="setRequestData($event)"
									*ngIf="requestListIAC?.length > 0">
								</cpi-input-with-autocomplete>
							</div>

							<div *ngIf="classificationStep === 'cmdb' && kmClassification.idCustomer !== ''">
								<pcp-cmdb-search-filter
									[customer]="kmClassification.idCustomer"
									[hideFilters]="['customer']"
									(getSelectedCi)="setCmdb($event)">
								</pcp-cmdb-search-filter>
							</div>

							<div class="button-container">
								<div *ngIf="classificationStep === 'request'" class="button" (click)="searchRequest()">
									<span>{{ labels.lbl_geral_buscar }}</span>
									<cpi-dot-bounce-loading-effect
										[color]="'var(--const-white)'"
										*ngIf="isLoadingSearchRequest"></cpi-dot-bounce-loading-effect>
								</div>
								<div class="button" (click)="addClassification()">{{ labels.lbl_geral_adicionar }}</div>
							</div>
						</div>

						<div class="added-classification-container">
							<span>{{ labels.lbl_cmdb_relacionamentos_adicionados }}</span>
							<div class="added-classification-header">
								<div
									class="tab"
									[ngClass]="{
										selected: selectedClassificationTab === 'classification',
										notify: notifyAddedClassification == true,
									}"
									(click)="notifyAddedClassification = false; selectedClassificationTab = 'classification'">
									{{ labels.lbl_geral_classificacao }}
								</div>
								<div
									class="tab"
									[ngClass]="{ selected: selectedClassificationTab === 'request', notify: notifyAddedRequest == true }"
									(click)="notifyAddedRequest = false; selectedClassificationTab = 'request'">
									{{ labels.lbl_geral_chamado }}
								</div>
								<div
									class="tab"
									[ngClass]="{ selected: selectedClassificationTab === 'cmdb', notify: notifyAddedCmdb == true }"
									(click)="notifyAddedCmdb = false; selectedClassificationTab = 'cmdb'">
									{{ labels.lbl_cmdb }}
								</div>
							</div>
							<div class="added-classification-body">
								<div
									class="classification-card"
									*ngIf="(selectedKb.classification | callback: kbClassificationFilter).length == 0">
									{{ labels.lbl_nenhum_item_tipo_registrado }}
								</div>
								<div
									class="classification-card"
									*ngFor="let classification of selectedKb.classification | callback: kbClassificationFilter">
									<span>
										{{ classification.customer }} -
										<ng-container *ngIf="classification.cmdb.idCmdb">
											{{ classification.cmdb.idCmdb }} - {{ classification.cmdb.identification }}
										</ng-container>
										<ng-container *ngIf="classification.request.id">
											{{ classification.solution_area }} - {{ classification.request.id }} -
											{{ classification.request.summary }}
										</ng-container>
										<ng-container *ngIf="classification.classification.topic">
											{{ classification.solution_area }} - {{ classification.classification.scope }} -
											{{ classification.classification.category }} - {{ classification.classification.topic }}
										</ng-container>
									</span>
									<span (click)="removeClassification(selectedKb.classification.indexOf(classification))">
										<fa-icon [icon]="icons.faTimes"></fa-icon>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="button-container mt-2">
					<div class="button" (click)="cleanArticlesList()">{{ labels.lbl_geral_limpar_campos }}</div>
					<div class="button" (click)="searchArticles()">{{ labels.lbl_geral_buscar }}</div>
				</div>

				<ng-container *ngIf="searchKbList.length > 0">
					<cpi-msp-table
						[header]="searchHeader"
						[body]="searchKbList | slice: paginationStart : paginationEnd"
						[maxHeight]="'55dvh'"
						[itemPadding]="'1%'"
						[labels]="labels"
						[sortDown]="true"
						(getSort)="sort($event['sortDown'])"
						(getSelectedItem)="getKbArchive($event[0]['id']); secondColView = 'kb'">
					</cpi-msp-table>

					<div class="table-articles">
						<cpi-pagination-counter
							[arrayLength]="searchKbList.length"
							[itemsPerPage]="10"
							(start)="paginationStart = $event"
							(end)="paginationEnd = $event">
						</cpi-pagination-counter>
					</div>
				</ng-container>
			</div>
		</div>

		<div
			class="not-chosen-col"
			[ngClass]="{ loading: secondColView === 'loading' }"
			*ngIf="secondColView === 'not-chosen' || secondColView === 'loading'">
			<cpi-svg-gears [gearSpinDurationMS]="10000"></cpi-svg-gears>
			<div>{{ secondColView === 'not-chosen' ? labels.lbl_selecione_uma_opcao : labels.lbl_edocs_carregando }}</div>
		</div>

		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true"></div>
	</div>

	<div
		class="ghost-screen"
		(mouseup)="ghostResizeBar.mouseDown = false"
		(mousemove)="handleGhostResizeBar($event)"
		*ngIf="ghostResizeBar.mouseDown"></div>
</div>

<div
	class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
	id="modalClose"
	(click)="modalClose($event, false)"
	*ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="icons.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<!-- Aparece ao estar carregando a página -->
<div class="loading-container" *ngIf="isLoadingLabels || isLoadingAccordion">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
